import artifact from './artifact'
import incident from './incident'
import recordings from './recordings'
import dataCollectorRecord from './dataCollectorRecord'
import dataCollectorAnnotation from './dataCollectorAnnotation.js'
import reports from './reports.js'
const filters = { artifact, incident, recordings, dataCollectorRecord, dataCollectorAnnotation, reports }

function useFilter(filterType) {
  return filters[filterType]
}

export { useFilter }
